export interface TipoEmpresa {
    id: number;
    nombre: string;
  }
  
  export const TIPOS_EMPRESA: TipoEmpresa[] = [
    { id: 1, nombre: 'PRIVADA' },
    { id: 2, nombre: 'MIXTA' },
    { id: 3, nombre: 'PUBLICA' },
    { id: 4, nombre: 'SECTOR SOLIDARIO' }
  ];